import { takeUntil } from 'rxjs/operators';
import { UnsubscribeOnDestroy } from 'src/app/_helpers/unsubscribe-on-destroy';
import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { AvisosService } from 'src/app/_services/avisos.service';
import { Observable } from 'rxjs';
import { Aviso } from 'src/app/model/aviso';
import { saveAs } from 'file-saver'
import { throwToolbarMixedModesError } from '@angular/material/toolbar';

@Component({
  selector: 'app-modal-avisos',
  templateUrl: './modal-avisos.component.html',
  styleUrls: ['./modal-avisos.component.css']
})
export class ModalAvisosComponent extends UnsubscribeOnDestroy implements OnInit {

  constructor(
    private avisosService: AvisosService
  ) {
    super();
  }

  avisos: Array<Aviso> = [];
  avisosVisibles: Array<Aviso> = [];
  avisosEmpty:boolean = false;
  documentAvailable:boolean = false;
  
  ngOnInit(): void {
    this.getAvisosVisibles();
  }


  getAvisos(): Observable<any>{
    return this.avisosService.getListAvisos()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
      next: (data) => {
        this.avisos = data.Aviso;
      },
      error: (err) => {
      }
    })
  }

  checkDocument() {

  }

  getAvisosVisibles(): Observable<any>{
    return this.avisosService.getAvisosVisible()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
      next: (data) => {
        this.avisosEmpty = false;
        this.avisosVisibles = data.Aviso;
        if(this.avisos.length === 0){
          this.avisosEmpty = true;
          
        }
      },
      error: (err) => { 
      }
    })
  }

  showPdf(base64, nombre) {
    const linkSource = 'data:application/pdf;base64,' + base64;
    const downloadLink = document.createElement("a");
    const fileName = nombre;

    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
}

}

